const polizas = [
  { slug: "cveerkamp-2026", cliente: "CVeerkamp", anio: 2026, pdf: "260311-Poliza-de-Servicios.pdf" },
  { slug: "eficasia-2025", cliente: "Eficasia", anio: 2025, pdf: "251118-Poliza-de-Servicios-X440-G2-48P.pdf" },
  { slug: "eficasia-2026", cliente: "Eficasia", anio: 2026, pdf: "260122-Poliza-de-Servicios.pdf" },
  { slug: "enestas-2025", cliente: "Enestas", anio: 2025, pdf: "251125-Poliza-Mtto-Fortinet-Enestas-Netjer.pdf" },
  { slug: "la-comer-2025", cliente: "La Comer", anio: 2025, pdf: "250707-Poliza-de-Servicios.pdf" },
  { slug: "havas-2026", cliente: "Havas", anio: 2026, pdf: "260306-Poliza-de-Servicios.pdf" },
  { slug: "icmyl-2025", cliente: "ICMyL", anio: 2025, pdf: "260330-Poliza-de-Servicios.pdf" },
  { slug: "icacc-2025", cliente: "ICACC", anio: 2025, pdf: "251126-Poliza-de-Servicios.pdf" },
  { slug: "mgavilan-2025-sw", cliente: "Mgavilan", anio: 2025, variante: "Switches", pdf: "251103-Poliza-de-Servicios_Switches.pdf" },
  { slug: "mgavilan-2025-fw", cliente: "Mgavilan", anio: 2025, variante: "Firewall", pdf: "251015-Poliza-de-Servicios_Firewall.pdf" },
  { slug: "ike-2026", cliente: "IKE", anio: 2026, pdf: "260217-Poliza-de-Servicios.pdf" },
  { slug: "k-networking-2026", cliente: "K-Networking", anio: 2026, pdf: "110526-Poliza-de-Servicios_K-Networking_X440_24P-5320-24P.pdf" },
  { slug: "uam-xochimilco-2026", cliente: "UAM Xochimilco", anio: 2026, pdf: "Poliza-eq-Extreme-UAMX-Feb25-Feb28-NNM.pdf" },
  { slug: "innes-aires-2026", cliente: "INNES AIRES", anio: 2026, pdf: "010726-Poliza-de-Servicios-Fortigate.pdf" },
];

export const tituloPoliza = (poliza) =>
  `Póliza ${poliza.cliente} ${poliza.anio}${poliza.variante ? ` - ${poliza.variante}` : ""}`;

export default polizas;
